import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { SiteTextsProvider } from "@/lib/texts";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import WhatsAppFab from "@/components/WhatsAppFab";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import MetaPixelTracker from "@/components/MetaPixelTracker";
import Privacy from "@/pages/Privacy";
import AdminAnalytics from "@/pages/AdminAnalytics";

import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Servizi from "@/pages/Servizi";
import Metodo from "@/pages/Metodo";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contatti from "@/pages/Contatti";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Quiz from "@/pages/Quiz";
import AuthCallback from "@/pages/AuthCallback";

import "@/App.css";

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <SiteTextsProvider>
          <ScrollToTop />
          <MetaPixelTracker />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-sono" element={<ChiSono />} />
              <Route path="/percorsi" element={<Servizi />} />
              <Route path="/metodo" element={<Metodo />} />
              <Route path="/casistudio" element={<Blog />} />
              <Route path="/casistudio/:slug" element={<BlogDetail />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registrati" element={<Register />} />
              <Route path="/quiz" element={<Navigate to="/checkup" replace />} />
              <Route path="/checkup" element={<Quiz />} />
              {/* Versione completa 42 domande: pubblicata ma non linkata (risorsa manuale per lead caldi) */}
              <Route path="/checkup-completo" element={<Quiz />} />
              <Route path="/auth-callback" element={<AuthCallback />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<AdminAnalytics />} />
            </Routes>
          </Layout>
          <WhatsAppFab />
          <CookieBanner />
          <Toaster position="top-right" richColors />
          </SiteTextsProvider>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
